/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";
import objectPath from "object-path";
import { connect } from "react-redux";
import { toAbsoluteUrl } from "../../utils/utils";
import * as builder from "../../ducks/builder";

class Footer extends React.Component {
  render() {
    const today = new Date().getFullYear();
    const { footerSelfLayoutIsExtended, footerClasses, footerContainerClasses } = this.props;
    return (
        <div
          className={`kt-footer ${footerClasses} m-grid__item m-footer bg-dark p-0 d-flex align-items-center`}
          id="kt_footer"
        >
          <div className="m-container m-container--responsive m-container--xxl m-container--full-height m-page__container">
                    <div className="m-footer__wrapper bg-transparent shadow-none">
                        <div className="m-stack m-stack--flex-tablet-and-mobile m-stack--ver m-stack--desktop">
                            <div className="m-stack__item m-stack__item--left m-stack__item--middle m-stack__item--last">
                                <span className="m-footer__copyright float-right text-white">
                                    © {new Date().getFullYear()}
                                </span>
                            </div>
                        </div>
                    </div>
          </div>
        </div>
    );
  }
}

const mapStateToProps = store => ({
  footerSelfLayoutIsExtended: objectPath.get(store.builder.layoutConfig, "footer.self.layout") === "extended",
  footerClasses: builder.selectors.getClasses(store, { path: "footer", toString: true}),
  footerContainerClasses: builder.selectors.getClasses(store, { path: "footer_container", toString: true}),
});

export default connect(mapStateToProps)(Footer);
